import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
var iconSizeSmall = {
	label: 6,
	title: "Small"
};
var iconSizeMedium = {
	label: 8,
	title: "Medium"
};
var iconSizeBig = {
	label: 10,
	title: "Big"
};
var textSizeSmall = {
	label: 2.5,
	title: "Small"
};
var textSizeMedium = {
	label: 3.5,
	title: "Medium"
};
var textSizeBig = {
	label: 4.5,
	title: "Big"
};
var defaultIcons = {
	N34: {
		4: 'icon-d6',
		5: 'icon-a4',
		6: 'icon-c6'
	},
	N35: {
		5: 'icon-d6',
		6: 'icon-a4',
		7: 'icon-c6'
	},
	CR: {
		0: 'icon-d6',
		1: 'icon-c6',
		2: 'icon-h3',
		3: 'emptyslot',
		4: 'emptyslot'
	},
	CH: {
		0: 'icon-d6',
		1: 'icon-c6',
		2: 'icon-h3',
		3: 'emptyslot',
		4: 'emptyslot'
	},
	KN: {
		9: 'icon-A-10-13',
		11: 'icon-A-11-16'
	}
}
const store = new Vuex.Store({
	state: {
		downloaderBroadcastChannel: process.env.VUE_APP_MODE + '_downloader_channel',
		downloaderBrodcastId: Math.floor(Math.random() * 1000),
		dxfServerURL: process.env.VUE_APP_DXF_SERVER_URL,
		serverURL: process.env.VUE_APP_SERVER_URL,
		user: null,
		artwork: {
			format: "single"
		},
		newArtworkToProductId: null,
		editedIdArtworkTool: null,
		bigIconSize: iconSizeBig.label, //double and slider icons are always big
		fontSizeMap: {
			'2.5': 7.5,
			'3.5': 9.4,
			'4.5': 12.6
		},
		textBoxHeight: {
			'2.5': 9,
			'3.5': 12.34,
			'4.5': 15.11
		},
		iconSizeMap: {
			6: 'small',
			8: 'medium',
			10: 'big'
		},
		textSizeMap: {
			'2.5': 'small',
			'3.5': 'medium',
			'4.5': 'big'
		},
		defaultUserFileTypePrivilegies : {
			pending: [],
			admin: ['XLS', 'JSON', 'DXF', 'CSV', 'PDF'],
			salesvp : ['PDF', 'XLS'],
			salesmanager : ['PDF', 'XLS', 'DXF'],
			distributors : ['PDF', 'CSV', 'XLS', 'JSON'],
			distributorsmanager : ['PDF', 'XLS'],
			dealers : ['PDF', 'XLS', 'JSON']
		},
		defaultUserPagePrivilegies: ['SR', 'TR', 'SP'],
		iconFontMap: {
			alba: {
				socket: {},
				iconOnly: {
					hasIconSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
				},
				singleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				}, //alba 8 keys and alba TT for big
				doubleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconSingleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconDoubleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconSingleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconDoubleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				}
			},
			aria: {
				socket: {},
				iconOnly: {
					hasIconSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
				},
				singleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				doubleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconSingleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconDoubleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconSingleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconDoubleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium],
					fontSize: [textSizeSmall, textSizeMedium]
				}
			},
			axes: {
				socket: {},
				iconOnly: {
					hasIconSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium, iconSizeBig]
				},
				singleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				doubleLineText: {
					hasFontSize: true,
					fontSize: [textSizeSmall, textSizeMedium, textSizeBig]
				},
				iconSingleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconDoubleLineTextMid: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeMedium, iconSizeBig],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconSingleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium],
					fontSize: [textSizeSmall, textSizeMedium]
				},
				iconDoubleLineText: {
					hasIconSize: true,
					hasFontSize: true,
					iconSize: [iconSizeSmall, iconSizeMedium],
					fontSize: [textSizeSmall, textSizeMedium]
				}
			},
			blackjack: {
				iconOnly: {
					hasIconSize: true,
					iconSize: [iconSizeMedium]
				},
			}
		},
		styleMap: {
			alba: {
				K2: {
					iconOnly: [1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5],
				},

				K4: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
				},
				K8: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5],
				},
				M1: {
					iconOnly: [1, 1, 1, 1, ],
					singleLineText: [2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5],
				},
				SK: {
					socket: []
				}
			},
			aria: {
				L12: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
					iconSingleLineTextMid: [1, 2, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1],
					iconDoubleLineTextMid: [1, 3, 1, 1, 3, 1, 1, 3, 1, 1, 3, 1],
					iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
				},
				M1: {
					iconOnly: [1, 1, 1, 1, 1, 1, ],
					singleLineText: [2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5],
				},
				SK: {
					socket: []
				}
			},
			axes: {
				L9: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3, 3],
					iconSingleLineTextMid: [1, 2, 1, 1, 2, 1, 1, 2, 1],
					iconDoubleLineTextMid: [1, 3, 1, 1, 3, 1, 1, 3, 1],
					iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5, 5],
				},
				TT: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
					singleLineText: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2],
					doubleLineText: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
					iconSingleLineText: [4, 4, 4, 4, 4, 4, 4, 4, 4, 4],
					iconDoubleLineText: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
				},
				CR: {
					iconOnly: [1, 1, 1, 1, 1, 6, 6, 6],
					singleLineText: [2, 2, 2, 2, 2, 6, 6, 6],
					doubleLineText: [3, 3, 3, 3, 3, 6, 6, 6],
					iconSingleLineText: [4, 4, 4, 4, 4, 6, 6, 6],
					iconDoubleLineText: [5, 5, 5, 5, 5, 6, 6, 6],
				},
				CH: {
					iconOnly: [1, 1, 1, 1, 1, 6, 6, 6],
					singleLineText: [2, 2, 2, 2, 2, 6, 6, 6],
					doubleLineText: [3, 3, 3, 3, 3, 6, 6, 6],
					iconSingleLineText: [4, 4, 4, 4, 4, 6, 6, 6],
					iconDoubleLineText: [5, 5, 5, 5, 5, 6, 6, 6],
				},
				DR: {
					iconOnly: [6],
				},
				KN: {
					iconOnly: [7, 7, 7, 7, 7, 7, 7, 7, 7, 1, 7, 1],
					singleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 2, 7, 2],
					doubleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 3, 7, 3],
					iconSingleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 4, 7, 4],
					iconDoubleLineText: [7, 7, 7, 7, 7, 7, 7, 7, 7, 5, 7, 5],
				},
				N34: {
					iconOnly: [7, 7, 7, 7, 1, 1, 1],
					singleLineText: [7, 7, 7, 7, 2, 2, 2],
					doubleLineText: [7, 7, 7, 7, 3, 3, 3],
					iconSingleLineText: [7, 7, 7, 7, 4, 4, 4],
					iconDoubleLineText: [7, 7, 7, 7, 5, 5, 5],
				},
				N35: {
					iconOnly: [7, 7, 7, 7, 7, 1, 1, 1],
					singleLineText: [7, 7, 7, 7, 7, 2, 2, 2],
					doubleLineText: [7, 7, 7, 7, 7, 3, 3, 3],
					iconSingleLineText: [7, 7, 7, 7, 7, 4, 4, 4],
					iconDoubleLineText: [7, 7, 7, 7, 7, 5, 5, 5],
				},
				SK: {
					socket: []
				}
			},
			blackjack: {
				K2: {
					iconOnly: [1, 1],
				},
				K4: {
					iconOnly: [1, 1, 1, 1],
				},
				K6: {
					iconOnly: [1, 1, 1, 1, 1, 1],
				},
				K8: {
					iconOnly: [1, 1, 1, 1, 1, 1, 1, 1],
				},
				M1: {
					iconOnly: [1, 1, 1, 1, 1, 1],
				}
			},
		},
		productCode: {
			category: 'K',
			series: { //type
				aria: 'R',
				alba: 'L',
				axes: 'H',
				blackjack: 'J'
			},
			opt1: { //type -> layout
				aria: {
					'L12': '12', //12 buttons
					'M1': 'M1', //Multipurpose OLED display with 6 physical buttons
					'SK': 'SK', //Socket
				},
				alba: {
					'K2': 'AA', //2 buttons
					'K4': 'BB', //4 buttons
					'K8': 'DD', //8 buttons
					'M1': 'M1', //Multipurpose OLED display with 4 physical buttons
					'SK': 'SK', //Socket
				},
				axes: {
					'L9': '09', //9 buttons
					'TT': 'TT', //Thermostat 7 seg and 10 buttons
					'CR': 'CH XX', //Max 9 addressable touch points without RFID
					'CH': 'CH RF', //Max 9 addressable touch points with RFID
					'DR': 'RF', //RGB Accessibility Status Indicator
					'KN': 'KN', //Numeric keypad
					'N34': 'N3', //Max 3 addressable touch points with 4 numbers
					'N35': 'N3', //Max 3 addressable touch points with 5 numbers
					'SK': 'SK', //Socket
				},
				blackjack: {
					'K2': 'A', //2 buttons
					'K4': 'B', //4 buttons
					'K6': 'C', //6 buttons
					'K8': 'D', //8 buttons
					'M1': 'M', //Multipurpose OLED display with 6 physical buttons
				}
			},
			opt2: { //format
				'single': '1F', //single
				'double': '2F', //double
				'vdouble': '2F', //vertical double
				'triple': '3F', //triple
				'vtriple': '3F' //vertical triple
			},
			opt3: { //protocol
				'Crestron': 'C',
				'KNX': 'K',
				'RS485': 'R'
			},
			opt4: { //material
				'black': 'G', //glass
				'white': 'G', //glass
				'yorkBlack': 'G', //glass
				'iceWhite': 'G', //glass
				'marsBlack': 'M', //metal
				'aluminiumSilver': 'M', //metal
				'sandWhite': 'G',
				'venetianGold': 'G',
				'bronzeGold': 'M',
				'so' : 'M',
				'fa' : 'M',
				'cc' : 'M',
				'ce' : 'M',
			},
			opt5: { //color
				'black': 'YB', //glass
				'white': 'IW', //glass
				'yorkBlack': 'YB', //glass
				'iceWhite': 'IW', //glass
				'marsBlack': 'MB', //Mars Black - metal brushed
				'aluminiumSilver': 'AS', //Aluminum Silver - metal brushed
				'amber': 'RU', //Raw Amber - metal brushed
				'sandWhite': 'SW',
				'venetianGold': 'VG',
				'bronzeGold': 'BG',
				'so' : 'SO',
				'fa' : 'FA',
				'cc' : 'CC',
				'ce' : 'CE',
			},
			opt6: {
				'square' : 'S',
				'round' : 'R'
			},
			prn: function (state) {
				if (state.artwork.format == 'single') return '';

				var L = '';
				var LEFT = state.productCode.opt1[state.artwork.type][state.artwork.layout];
				var RIGHT = state.productCode.opt1[state.artwork.type][state.artwork.rightLayout];
				var TRIPLE_RIGHT = (store.getters.isTriple) ? state.productCode.opt1[state.artwork.type][state.artwork.tripleRightLayout] : '';


				if (state.artwork.layout == 'SK' || state.artwork.rightLayout == 'SK' || (state.artwork.tripleRightLayout == 'SK' && (store.getters.isTriple))) {
					L = 'LA';
				}

				return LEFT + RIGHT + TRIPLE_RIGHT + L;
			}
		},
		defaultIconColors: {
			'white': '#000000',
			'black': '#ffffff',
			'yorkBlack': '#ffffff',
			'iceWhite': '#b2b2b2',
			'sandWhite': '#b2b2b2',
			'venetianGold': '#3e2a16',
			'so': "#ffffff",
			'fa': '#000000',
			'cc': '#E2BA51',
			'ce': '#3e2a16'
		},
		userTypeMap: {
			'pending': 'Pending',
			'admin': 'Admin',
			'salesvp': 'Sales VP',
			'salesmanager': 'SalesManager',
			'distributors': 'Partner',
			'distributorsmanager': 'PartnerManager',
			'dealers': 'Dealers'
		}

	},
	getters: {
		downloaderBroadcastChannel: (state) => (id = null) => {
			if (id == null) {
				id = state.downloaderBrodcastId;
			}
			return state.downloaderBroadcastChannel + '_' + id;
		},
		divider(state) { //style layout divider
			var format = {
				single: 1,
				double: 2,
				vdouble: 1,
				triple: 3,
				vtriple: 1,
			};
			return format[state.artwork.format];
		},
		canDownloadFile: (state) => (type) => {
			if (type == 'DXF' && state.artwork.type == 'blackjack') {
				return false;
			}
			if (state.user != null && typeof state.user.checkedPagePermissions !== 'undefined') {
				return state.user.checkedFilePermissions.includes(type);
			}
			return true;
		},
		canSeePage: (state) => (page) => {
			if (state.user != null && typeof state.user.checkedPagePermissions !== 'undefined') {
				return state.user.checkedPagePermissions.includes(page);
			}
			return true;
		},
		isVertical(state) {
			return state.artwork.format.substring(0,1).includes('v')
		},

		isDouble(state) {
			return state.artwork.format.includes('double');
		},

		isTriple(state) {
			return state.artwork.format.includes('triple');
		},
		hOrV(state, getters) {
			var hOrV = getters.isVertical ? "vertical" : "horizontal";
			hOrV = getters.isTriple ? hOrV + "  triple" : hOrV;

			return hOrV;
		}, 
	},

	mutations: {
		changeFontColor(state, color) {
			for (var i = 0; i < state.artwork.content.length; i++) {
				state.artwork.content[i].color = color
			}
			if (typeof state.artwork.rightContent != 'undefined') {
				for (i = 0; i < state.artwork.rightContent.length; i++) {
					state.artwork.rightContent[i].color = color
				}
			}
			if (typeof state.artwork.tripleRightContent != 'undefined') {
				for (i = 0; i < state.artwork.tripleRightContent.length; i++) {
					state.artwork.tripleRightContent[i].color = color
				}
			}
		},
		setAlignment(state, payload) {
			if (typeof state.artwork.content[payload.index] != 'undefined') {
				state.artwork.content[payload.index].alignment = payload.alignment;
			}
		},
		setRightAlignment(state, payload) {
			if (typeof state.artwork.rightContent[payload.index] != 'undefined') {
				state.artwork.rightContent[payload.index].alignment = payload.alignment;
			}
		},
		setTripleRightAlignment(state, payload) {
			if (typeof state.artwork.tripleRightContent[payload.index] != 'undefined') {
				state.artwork.tripleRightContent[payload.index].alignment = payload.alignment;
			}
		},
		getContent(state) {
			var content = []
			var singleContent
			var mainIcon = 'icon-a'
			var style = state.styleMap[state.artwork.type][state.artwork.layout][state.artwork.layoutStyle]

			if (state.artwork.type == 'blackjack') {
				mainIcon = 'icon-C-01-01'
			}
			for (var i = 0; i < style.length; i++) {
				switch (style[i]) {
					case 1:
						singleContent = {
							hasIcon: true,
							icon: mainIcon,
							type: 'normal'
						}
						if (typeof defaultIcons[state.artwork.layout] != 'undefined') {
							singleContent.icon = defaultIcons[state.artwork.layout][i] || mainIcon;
						}
						break;
					case 2:
						singleContent = {
							hasTextL1: true,
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 3:
						singleContent = {
							hasTextL1: true,
							hasTextL2: true,
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 4:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							icon: mainIcon,
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 5:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							hasTextL2: true,
							icon: mainIcon,
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 6:
						if (state.artwork.layout == 'CH' || state.artwork.layout == 'CR') {
							if (i == 5) {
								singleContent = {
									hasIcon: true,
									icon: "icon-A-05-04",
									iconSize: 14.7,
									disabled: true,
									type: 'backlight'
								}
							} else {
								singleContent = {
									hasIcon: true,
									icon: "icon-circle",
									iconSize: 7.8,
									disabled: true,
									type: 'backlight'
								}
							}
						} else if (state.artwork.layout == 'DR') {
							singleContent = {
								hasIcon: true,
								icon: "icon-c4",
								iconSize: 12.4,
								disabled: true,
								type: 'backlight'
							}
						}
						break;
					case 7:
						if (state.artwork.layout == 'KN') {
							let text = i + 1;
							if (text == 11) {
								text = 0;
							}
							singleContent = {
								hasTextL1: true,
								textL1: text.toString(),
								fontSize: 22,
								disabled: true,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.layout == 'N34') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 110,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.layout == 'N35') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 90,
								isNumber: true,
								type: 'backlight'
							}
						}
						break;
				}

				if (state.artwork.type == 'aria' || state.artwork.type == 'axes') {
					singleContent.color = state.defaultIconColors[state.artwork.frameColor];
				} else {
					singleContent.color = state.defaultIconColors[state.artwork.keyColor];
				}

				content.push(singleContent)

			}
			state.artwork.content = content;
		},
		getTripleRightContent(state) {
			if (typeof state.artwork.tripleRightLayout == 'undefined') return;

			var content = []
			var singleContent
			var style = state.styleMap[state.artwork.type][state.artwork.tripleRightLayout][state.artwork.tripleRightLayoutStyle]
			for (var i = 0; i < style.length; i++) {
				switch (style[i]) {
					case 1:
						singleContent = {
							hasIcon: true,
							icon: "icon-a",
							type: 'normal'
						}
						if (typeof defaultIcons[state.artwork.tripleRightLayout] != 'undefined') {
							singleContent.icon = defaultIcons[state.artwork.tripleRightLayout][i] || "icon-a";
						}
						break;
					case 2:
						singleContent = {
							hasTextL1: true,
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 3:
						singleContent = {
							hasTextL1: true,
							hasTextL2: true,
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 4:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							icon: "icon-a",
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 5:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							hasTextL2: true,
							icon: "icon-a",
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 6:
						if (state.artwork.tripleRightLayout == 'CH' || state.artwork.layout == 'CR') {
							singleContent = {
								hasIcon: true,
								icon: "icon-A-05-04",
								iconSize: 14.7,
								disabled: true,
								type: 'backlight'
							}
						} else if (state.artwork.tripleRightLayout == 'DR') {
							singleContent = {
								hasIcon: true,
								icon: "icon-c4",
								iconSize: 12.4,
								disabled: true,
								type: 'backlight'
							}
						}
						break;
					case 7:
						if (state.artwork.tripleRightLayout == 'KN') {
							let text = i + 1;
							if (text == 11) {
								text = 0;
							}
							singleContent = {
								hasTextL1: true,
								textL1: text.toString(),
								fontSize: 22,
								disabled: true,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.tripleRightLayout == 'N34') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 110,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.tripleRightLayout == 'N35') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 90,
								isNumber: true,
								type: 'backlight'
							}
						}
						break;
				}
				if (state.artwork.type == 'aria' || state.artwork.type == 'axes') {
					singleContent.color = state.defaultIconColors[state.artwork.frameColor];

				} else {
					singleContent.color = state.defaultIconColors[state.artwork.keyColor];
				}

				content.push(singleContent)
			}
			state.artwork.tripleRightContent = content;
		},

		getRightContent(state) {
			if (typeof state.artwork.rightLayout == 'undefined') return;

			var content = []
			var singleContent
			var style = state.styleMap[state.artwork.type][state.artwork.rightLayout][state.artwork.rightLayoutStyle]
			for (var i = 0; i < style.length; i++) {
				switch (style[i]) {
					case 1:
						singleContent = {
							hasIcon: true,
							icon: "icon-a",
							type: 'normal'
						}
						if (typeof defaultIcons[state.artwork.rightLayout] != 'undefined') {
							singleContent.icon = defaultIcons[state.artwork.rightLayout][i] || "icon-a";
						}
						break;
					case 2:
						singleContent = {
							hasTextL1: true,
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 3:
						singleContent = {
							hasTextL1: true,
							hasTextL2: true,
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 4:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							icon: "icon-a",
							textL1: 'textl1',
							type: 'normal'
						}
						break;
					case 5:
						singleContent = {
							hasIcon: true,
							hasTextL1: true,
							hasTextL2: true,
							icon: "icon-a",
							textL1: 'textl1',
							textL2: 'textl2',
							type: 'normal'
						}
						break;
					case 6:
						if (state.artwork.rightLayout == 'CH' || state.artwork.layout == 'CR') {
							singleContent = {
								hasIcon: true,
								icon: "icon-A-05-04",
								iconSize: 14.7,
								disabled: true,
								type: 'backlight'
							}
						} else if (state.artwork.rightLayout == 'DR') {
							singleContent = {
								hasIcon: true,
								icon: "icon-c4",
								iconSize: 12.4,
								disabled: true,
								type: 'backlight'
							}
						}
						break;
					case 7:
						if (state.artwork.rightLayout == 'KN') {
							let text = i + 1;
							if (text == 11) {
								text = 0;
							}
							singleContent = {
								hasTextL1: true,
								textL1: text.toString(),
								fontSize: 22,
								disabled: true,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.rightLayout == 'N34') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 110,
								isNumber: true,
								type: 'backlight'
							}
						} else if (state.artwork.rightLayout == 'N35') {
							singleContent = {
								hasTextL1: true,
								textL1: "0",
								fontSize: 90,
								isNumber: true,
								type: 'backlight'
							}
						}
						break;
				}
				if (state.artwork.type == 'aria' || state.artwork.type == 'axes') {
					singleContent.color = state.defaultIconColors[state.artwork.frameColor];

				} else {
					singleContent.color = state.defaultIconColors[state.artwork.keyColor];
				}

				content.push(singleContent)
			}
			state.artwork.rightContent = content;
		},

		getProductCode(state) {
			var pc = state.productCode;
			var layout = pc.opt1[state.artwork.type][state.artwork.layout];
			if (store.getters.isDouble || store.getters.isTriple) {
				layout = 'CO';
			} else if (['RF', 'KN', 'N3'].includes(layout)) {
				layout = 'DP ' + layout;
			}
			
			if (state.artwork.type == 'blackjack') {
				state.artwork.productCode = pc.category + ' ' +
				pc.series[state.artwork.type] + ' ' +
				pc.opt3[state.artwork.protocol] + ' ' +
				'1' + ' ' + //as single format
				pc.opt4[state.artwork.frameColor] + ' ' +
				pc.opt5[state.artwork.frameColor] + ' ' +
				layout + ' ' +
				pc.opt4[state.artwork.keyColor] + ' ' +
				pc.opt5[state.artwork.keyColor] + ' ' +
				pc.opt6[state.artwork.buttonFormat]
			} else {
				state.artwork.productCode = pc.category + ' ' +
				pc.series[state.artwork.type] + ' ' +
				layout + ' ' +
				((state.artwork.type == 'axes' && state.artwork.format == 'single' && !['L9', 'TT'].includes(state.artwork.layout)) ? '' : pc.opt2[state.artwork.format] + ' ') +
				pc.opt3[state.artwork.protocol] + ' ' +
				pc.opt4[state.artwork.frameColor] + ' ' +
				((pc.opt4[state.artwork.frameColor] == 'G') ? '' : pc.opt5[state.artwork.frameColor] + ' ') +
				pc.prn(state) + ' ' +
				((store.getters.isVertical) ? 'V' : '') + ' ' +
				((state.artwork.productLine == 'Classic') ? '-C' : '')
			}
			
		}
	},
	actions: {},
	modules: {}
})

export default store;